import type { Movie } from "@/types/media";

export const GENRES = ["剧情", "悬疑", "犯罪", "爱情", "都市", "奇幻", "冒险", "青春", "科幻", "家庭", "励志", "惊悚", "武侠", "古装", "文艺", "西部"];

export const REGIONS = ["国产", "欧美", "日韩"];

export const YEAR_RANGES = [
  { label: "2024", min: 2024, max: 2024 },
  { label: "2023", min: 2023, max: 2023 },
  { label: "2022", min: 2022, max: 2022 },
  { label: "2021", min: 2021, max: 2021 },
  { label: "2020", min: 2020, max: 2020 },
  { label: "2020 以前", min: 0, max: 2019 },
];

export interface FilterState {
  genres: string[];
  region: string;
  yearLabel: string;
  keyword: string;
}

export const emptyFilters: FilterState = {
  genres: [],
  region: "",
  yearLabel: "",
  keyword: "",
};

export function filterMovies(list: Movie[], filters: FilterState): Movie[] {
  return list.filter((m) => {
    if (filters.genres.length > 0 && !filters.genres.some((g) => m.genres.includes(g))) {
      return false;
    }
    if (filters.region && m.region !== filters.region) {
      return false;
    }
    if (filters.yearLabel) {
      const range = YEAR_RANGES.find((r) => r.label === filters.yearLabel);
      if (range && (m.year < range.min || m.year > range.max)) {
        return false;
      }
    }
    if (filters.keyword) {
      const kw = filters.keyword.trim().toLowerCase();
      const haystack = [
        m.title,
        m.director,
        m.region,
        m.genres.join(" "),
        m.actors.map((a) => a.name).join(" "),
        m.summary,
      ]
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(kw)) {
        return false;
      }
    }
    return true;
  });
}

export type SortKey = "latest" | "hot";

export function sortMovies(list: Movie[], sort: SortKey): Movie[] {
  const copy = [...list];
  if (sort === "hot") {
    copy.sort((a, b) => b.views - a.views);
  } else {
    copy.sort((a, b) => b.year - a.year || b.views - a.views);
  }
  return copy;
}

export function paginate<T>(list: T[], page: number, perPage: number) {
  const total = list.length;
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * perPage;
  return {
    items: list.slice(start, start + perPage),
    totalPages,
    total,
    page: safePage,
  };
}

export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return String(views);
}

export const categoryMeta: Record<string, { title: string; desc: string; type: string }> = {
  tv: {
    title: "电视剧",
    desc: "最新电视剧资讯与剧情介绍，涵盖悬疑、都市、家庭、武侠等多种题材，帮你找到正在追的那部剧。",
    type: "电视剧",
  },
  movie: {
    title: "电影",
    desc: "热门电影推荐与剧情介绍，覆盖国产、欧美、日韩佳片，快速了解口碑与看点。",
    type: "电影",
  },
};